import { Button } from '@blueprintjs/core'
import * as classnames from 'classnames/bind'
import * as firebase from 'firebase'
import * as moment from 'moment'
import 'moment-duration-format'
import * as R from 'ramda'
import * as React from 'react'

import { connect } from 'react-redux'
import { dispatch, RootState, select, store } from '../../store'
import Avatar from '../Avatar'
import styles from './reply-item.scss'

import TextInput from '../TextInput/textArea'

const cx = classnames.bind(styles)

// true
interface IProps extends Partial<ReturnType<typeof mapState>> {
  replyId: string
  lectureId: string
  insightId: string
  materialIdx: number
}

class ReplyItem extends React.Component<IProps> {
  public state = {
    isEdit: false,
    editValue: ``
  }
  public componentDidMount = () => {
    const rootState = store.getState()
    const { replyId } = this.props
    const reply = select.replies.getById(rootState, replyId)
    if (reply) {
      const replier = select.users.getById(rootState, reply.replierId)
      if (!replier) {
        dispatch.users.fetchUsers([reply.replierId])
      }
    } else {
      dispatch.replies.fetchReplies([replyId])
    }
  }
  public componentWillReceiveProps = (nextProps: IProps) => {
    const rootState = store.getState()
    const { replyId } = nextProps
    const reply = select.replies.getById(rootState, replyId)
    this.setState({ editValue: reply ? this.html2Text(reply.text) : `` })
  }
  public toggleEditMessage = () => {
    const { isEdit } = this.state
    this.setState({ isEdit: !isEdit })
  }
  public onConfirmtMessage = () => {
    const { isEdit, editValue } = this.state
    this.setState({ isEdit: !isEdit })
    const { replyId } = this.props

    dispatch.replies.updateReply({
      replyId,
      updated: { text: this.text2Html(editValue) }
    })
  }
  public editingMessage = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const value = event.currentTarget.value
    this.setState({ editValue: value })
  }
  public sliceString = (s: string) => {
    let newStr = s.split('')
    newStr = newStr.slice(0, -4)
    newStr.splice(0, 3)
    return newStr.join('')
  }
  public html2Text = (str: string) => {
    return `${str.replace(/<br\s*\/?>/gi, '\n')}`
  }
  public text2Html = (str: string) => {
    return `${str}`.replace(/(?:\r\n|\r|\n)/g, '\n')
  }

  public render() {
    const rootState = store.getState()
    const { replyId } = this.props
    const { isEdit } = this.state
    const currentUser = firebase.auth().currentUser
    const reply = select.replies.getById(rootState, replyId)
    const activeLike =
      currentUser && reply
        ? R.contains(currentUser.uid, reply.reactions.like)
        : false
    const replier = reply
      ? select.users.getById(store.getState(), reply.replierId)
      : null
    const isCurrentUserReply =
      reply && currentUser ? reply.replierId === currentUser.uid : false
    let duration = ''
    if (reply) {
      const diff = moment.duration(
        moment().diff(moment.unix(reply.ts.seconds)) / 1000,
        'second'
      )
      if (diff.years()) {
        duration = `${diff.years()} 年前`
      } else if (diff.months()) {
        duration = `${diff.months()} 月前`
      } else if (diff.weeks()) {
        duration = `${diff.weeks()} 週前`
      } else if (diff.days()) {
        duration = `${diff.days()} 天前`
      } else if (diff.hours()) {
        duration = `${diff.hours()} 小時前`
      } else if (diff.minutes()) {
        duration = `${diff.minutes()} 分鐘前`
      } else if (diff.seconds()) {
        duration = `${diff.seconds()} 秒前`
      } else {
        duration = `不到一秒前`
      }
    }
    return (
      <div className={cx('message-item')}>
        <div className={cx('message-item__inner')}>
          <div className={cx('message-item__avatar')}>
            <Avatar userId={reply ? reply.replierId : undefined} />
          </div>
          <div className={cx('message-item__info')}>
            <div className={cx('message-item__name')}>
              {replier ? replier.fullName : 'N/A'}
            </div>
            <div className={cx('message-item__content', { isEdit })}>
              {isEdit ? (
                <TextInput
                  className={cx('editable_para')}
                  disabled={currentUser === null}
                  onChange={this.editingMessage}
                  defaultValue={reply ? this.html2Text(reply.text) : ``}
                  rows={4}
                  style={{ lineHeight: `24px`, height: `72px` }}
                />
              ) : (
                // className={cx('message-item__comment-input')} />
                <div
                  className={cx('para')}
                  dangerouslySetInnerHTML={{
                    __html: reply
                      ? `<pre>${this.html2Text(reply.text)}</pre>`
                      : '讀取中'
                  }}
                />
              )}
              {isCurrentUserReply ? (
                <div className={cx('message_toolbox')}>
                  {isEdit ? (
                    <div className={cx('editing_btn')}>
                      <div onClick={this.onConfirmtMessage}>確認</div>
                      <div
                        className={cx('cancel_btn')}
                        onClick={this.toggleEditMessage}
                      >
                        取消
                      </div>
                    </div>
                  ) : (
                    <div className={cx('trigger_editing_btn')}>
                      <Button
                        icon="edit"
                        text=""
                        active={false}
                        className={cx('')}
                        onClick={this.toggleEditMessage}
                      />
                    </div>
                  )}
                </div>
              ) : null}
            </div>
            <div className={cx('message-item__footer')}>
              <div
                className={cx('message-item__like', { active: activeLike })}
                onClick={this.handleLikeToggle}
              >
                <span>{reply ? reply.reactions.like.length : '-'}</span>
                <span>人喜歡</span>
              </div>
              <span className={cx('message-item__comment-date')}>
                {duration}
              </span>
            </div>
          </div>
        </div>
      </div>
    )
  }
  private handleLikeToggle = () => {
    const { lectureId, insightId, materialIdx, replyId } = this.props
    dispatch.replies.toggleReaction({
      lectureId,
      insightId,
      chapterIdx: -1,
      materialIdx,
      replyId,
      reaction: 'like'
    })
  }
}

const mapState = ({ auth, users, replies }: RootState) => ({
  auth,
  users,
  replies
})

export default connect(mapState)(ReplyItem)



// WEBPACK FOOTER //
// ./src/components/ReplyItem/index.tsx